import * as React from 'react'
import { useCallback, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { ReadRegistrationDto } from 'api-client'
import { RegistrationsStore } from 'store/registrations.store'
import { Listing } from 'shared/components/listing/Listing'
import { columns } from './registration-list.columns'

export const RegistrationList = observer(() => {
  useEffect(() => {
    RegistrationsStore.loadRegistrations()
  }, [])

  const deleteItem = useCallback((id: string) => RegistrationsStore.deleteCategory(id), [])

  return (
    <div>
      <Listing<ReadRegistrationDto>
        data={RegistrationsStore!.registrations!}
        columns={columns(deleteItem)}
      />
    </div>
  )
})
